import * as React from 'react';
import { Page } from 'components/page/page';
import { Card } from 'components/card/card';
import { Table } from 'components/table/table';
import { getAllRates, updateRate } from 'core/repositories/getRates';
import { digitSperator } from '../../../../core/utils/decimalExtentions';
import { Button, Input, Switch } from 'antd';
import { FiatRates } from 'core/domain/fiat/fiat';
import { useState } from 'react';

export const FiatTable: React.FC = () => {
    const [allRates, setAllRates] = useState<FiatRates[]>([]);
    const [loading, setLoading] = useState<boolean>(false);

    React.useEffect(() => {
        getAllRates(setLoading, setAllRates);
    }, []);

    // Function to handle the update for a specific row
    const handleUpdate = async (row: FiatRates) => {
        const updatedRateData = {
            symbol: row.symbol, // Assuming `id` is part of the FiatRates structure
            buyPrice: row.buyPrice, // Use the current input value
            sellPrice: row.sellPrice, // Use the current input value
            isActive: row.isActive,
        };
        await updateRate(setLoading, updatedRateData);
    };

    const columns: any[] = [
        {
            name: 'نام ارز',
            id: 'name',
            selector: (row: FiatRates) => row.name,
            width: '20%',
        },
        {
            name: 'نشانه ارز',
            id: 'symbol',
            selector: (row: FiatRates) => row.symbol,
            width: '15%',
            cell: (row: FiatRates) => <span className="en">{row.symbol}</span>,
        },
        {
            name: 'قیمت خرید',
            id: 'buy',
            selector: (row: FiatRates) => digitSperator(row.buyPrice),
            width: '20%',
            cell: (row: FiatRates) => (
                <Input
                    value={digitSperator(row.buyPrice)} // Controlled value
                    onChange={(e) => {
                        const value = e.target.value.replace(/,/g, ''); // Remove commas
                        row.buyPrice = parseFloat(value) || 0; // Update the row directly
                        // Force a re-render by setting state
                        setAllRates([...allRates]); // Trigger a re-render
                    }}
                />
            ),
        },
        {
            name: 'قیمت فروش',
            id: 'sell',
            selector: (row: FiatRates) => digitSperator(row.sellPrice),
            width: '20%',
            cell: (row: FiatRates) => (
                <Input
                    value={digitSperator(row.sellPrice)} // Controlled value
                    onChange={(e) => {
                        const value = e.target.value.replace(/,/g, ''); // Remove commas
                        row.sellPrice = parseFloat(value) || 0; // Update the row directly
                        // Force a re-render by setting state
                        setAllRates([...allRates]); // Trigger a re-render
                    }}
                />
            ),
        },
        {
            name: 'فعال بودن',
            id: 'isActive',
            selector: (row: FiatRates) => row.isActive,
            width: '15%',
            cell: (row: FiatRates) => (
                <Switch
                    checked={row?.isActive}
                    onChange={(checked) => {
                        row.isActive = checked;
                        setAllRates([...allRates]);
                    }}
                />
            ),
        },
        {
            name: 'عملیات',
            id: 'submit',
            width: '10%',
            cell: (row: FiatRates) => (
                <Button block type="primary" onClick={() => handleUpdate(row)}>
                    اعمال
                </Button>
            ),
        },
    ];

    return (
        <Page className="pmx-zibal-transactions">
            <Card title="تغییر نرخ" blur={loading}>
                {allRates && (
                    <Table
                        blur={loading}
                        className="zibal-transactions-table"
                        data={allRates}
                        column={columns}
                        setPageSize={null}
                    />
                )}
            </Card>
        </Page>
    );
};
